// Components
import maInputSelect from '@/components/input/modules/select'
import maFilters from '../../../../components/filters'

// api
import {
  apiGetChartWarrantyTypes,
  apiGetChartWarrantySubtypes
} from '@/services/API/chart'

import { isBefore, isAfter, sub, format, add } from 'date-fns'

const date = (stringDate) => {
  if (stringDate) return new Date(stringDate)
  else return new Date()
}
const currentDate = format(date(), 'yyyy-MM-dd')
const dateRange = { months: 11 }

/**
 * @module
 * @name data-filter
 */
export default {
  name: 'data-filter',

  data: function () {
    return {
      filter: {
        warranty: null,
        subwarranty: null,
        fromDate: {
          value: null,
          min: null,
          max: null
        },
        toDate: {
          value: null,
          min: null,
          max: null
        }
      },
      warrantyTypes: [],
      subwarrantyTypes: []
    }
  },
  components: {
    maFilters,
    maInputSelect
  },
  props: {
    dataArrFilters: {
      type: Object | Array
    },
    dataArrLabels: {
      type: Array
    },
    handleClickFilter: {
      type: Function
    },
    selectedOption: {
      type: String
    },
    handleClickDownloadBtn: {
      type: Function
    },
    showHintToDate: {
      type: Boolean
    },
    showHintFromDate: {
      type: Boolean
    }
  },
  methods: {
    setDateRange () {
      const { fromDate, toDate } = this.filter

      if ((!fromDate.value && !toDate.value) || (fromDate.value && toDate.value)) {
        fromDate.min = null
        fromDate.max = currentDate
        toDate.min = null
        toDate.max = currentDate
      }

      if (!fromDate.value && toDate.value) {
        fromDate.min = format(sub(date(toDate.value), dateRange), 'yyyy-MM-dd')
        fromDate.max = currentDate
        toDate.min = null
        toDate.max = currentDate
      }

      if (fromDate.value && !toDate.value) {
        fromDate.min = null
        fromDate.max = currentDate
        toDate.min = null
        toDate.max = isBefore(add(date(fromDate.value), dateRange), new Date()) ? format(add(date(fromDate.value), dateRange), 'yyyy-MM-dd') : currentDate
      }
    },

    handleFromDateChange () {
      if (
        isAfter(date(this.filter.fromDate.value), date(this.filter.toDate.value)) ||
        isBefore(date(this.filter.fromDate.value), sub(date(this.filter.toDate.value), dateRange))
      ) {
        this.filter.toDate.value = null
        this.$emit('toDate:change', null)
        this.$emit('fromDate:change', this.filter.fromDate.value)
      } else {
        this.$emit('fromDate:change', this.filter.fromDate.value)
      }
      this.setDateRange()
    },

    handleToDateChange () {
      if (
        isBefore(date(this.filter.toDate.value), date(this.filter.fromDate.value)) ||
        isAfter(date(this.filter.toDate.value), add(date(this.filter.fromDate.value), dateRange))
      ) {
        this.filter.fromDate.value = null
        this.$emit('fromDate:change', null)
        this.$emit('toDate:change', this.filter.toDate.value)
      } else {
        this.$emit('toDate:change', this.filter.toDate.value)
      }
      this.setDateRange()
    },

    /**
     * @function
     * @name setWarrantyTypesFilter
     * @description Get warranty types from backend.
     */
    setWarrantyTypesFilter: function () {
      apiGetChartWarrantyTypes()
        .then(types => {
          if (types && types.length > 0) {
            this.warrantyTypes = types
            this.warrantyTypes.push({
              'key': 0,
              'literal': this.$t('common.noSelected')
            })
            this.warrantyTypes.sort((a, b) => a.key - b.key)
          }
        })
    },

    /**
     * @function
     * @name setWarrantySubtypesFilter
     * @description Get subwarranty types from backend.
     */
    setWarrantySubtypesFilter: function () {
      apiGetChartWarrantySubtypes(this.filter.warranty)
        .then(subtypes => {
          if (subtypes && subtypes.length > 0) {
            this.subwarrantyTypes = subtypes
            this.subwarrantyTypes.push({
              'key': 0,
              'literal': this.$t('common.noSelected')
            })
            this.subwarrantyTypes.sort((a, b) => a.key - b.key)
          }
        })
    },

    /**
     * @function
     * @name handleFilterChange
     * @param {String} event Filter warranty id.
     * @description Set local state filter, update subwarranty types and emit
     *  an event that will be caught to update table data.
     */
    handleFilterChange: function (event) {
      if (event) {
        this.filter.warranty = event
        this.filter.subwarranty = null
        this.subwarrantyTypes = []
        this.setWarrantySubtypesFilter()
        this.$emit('filterWarranty:change', this.filter)
      } else {
        this.filter.subwarranty = null
        this.filter.warranty = null
        this.subwarrantyTypes = []
        this.warrantyTypes = []
        this.$emit('filterWarranty:change', this.filter)
      }
    },

    /**
     * @function
     * @name handleSubfilterChange
     * @param {String} event Filter subwarranty id.
     * @description Set local state subfilter to handler event. Emit an event to be
     *  caught in order to update table data.
     */
    handleSubfilterChange: function (event) {
      if (event) {
        this.filter.subwarranty = event
        this.$emit('filterSubWarranty:change', this.filter)
      } else {
        this.filter.subwarranty = null
        this.$emit('filterSubWarranty:change', this.filter)
      }
    }
  },
  watch: {
    subwarrantyTypes (value) {
      if (value.length === 0) {
        this.subwarrantyTypes.push({
          'key': 0,
          'literal': this.$t('common.noSelected')
        })
      }
    }
  },
  /**
   * @function
   * @name mounted
   * @description Init warranty types.
   */
  mounted () {
    this.subwarrantyTypes.push({
      'key': 0,
      'literal': this.$t('common.noSelected')
    })
    this.setWarrantyTypesFilter()
    this.setDateRange()
  }
}
